export default __webpack_public_path__ + "static/11-e4cae39b59c571f2f59204f71125edc0.jpg";